import common from "./common"
import filmReview from "./filmReview"
import Operating from './Operating'
import Live from './Live'
import netFly from './netfly'

export default {
  ...Live,
  ...common,
  ...filmReview,
  ...Operating,
  ...netFly,
  '点播内容': {
    zh: '点播内容',
    ar: 'المحتوى حسب الطلب',
    en: 'VOD',
    fa: 'محتوای روی تقاضا',
    pt: 'VOD'
  },
  '影片审核': {
    zh: '影片审核',
    ar: 'مراجعة الفيلم',
    en: 'Review',
    fa: 'بررسی فیلم',
    pt: 'Análise'
  },
  '影片管理': {
    zh: '影片管理',
    ar: 'إدارة الأفلام',
    en: 'Management',
    fa: 'مدیریت فیلم',
    pt: 'Gerenciamento'
  },
  '系列影片': {
    zh: '系列影片',
    ar: 'سلسلة أفلام',
    en: 'Movie Sets',
    fa: 'فیلم سری',
    pt: 'Conjuntos Filmes'
  },
  '运营管理': {
    zh: '运营管理',
    en: 'Operations',
    ar: 'إدارة العمليات',
    fa: 'مدیریت عملیات',
    pt: 'Operações'
  },
  '产品运营': {
    zh: '产品运营',
    en: 'Product Operations',
    ar: 'عمليات المنتج',
    fa: 'عملیات محصول',
    pt: 'Operações do Produto'
  },
  '首页': {
    zh: '首页',
    en: 'Home',
    ar: 'وطن',
    fa: 'خانه',
    pt: 'Página Inicial'
  },
  '权限设置': {
    zh: '权限设置',
    en: 'Authority',
    ar: 'القوة',
    fa: 'قدرت',
    pt: 'Autoridade'
  },
  '系统日志': {
    zh: '系统日志',
    en: 'CMS Log',
    ar: 'سجل CMS',
    fa: 'یاداشت CMS',
    pt: 'Log CMS'
  },
  '点播日志': {
    zh: '点播日志',
    en: 'Vod Log',
    ar: 'سجل الطلب',
    fa: 'در لیست عملیات خواسته',
    pt: 'Log Vod'
  },
  '点播转码': {
    zh: '点播转码',
    en: 'VOD Transcode',
    ar: 'الفيديو حسب الطلب',
    fa: 'ترنسکود VOD',
    pt: 'Transcodificação VOD'
  },
  '任务管理': {
    zh: '任务管理',
    en: 'Task Management',
    ar: 'إدارة المهام',
    fa: 'مدیریت کار',
    pt: 'Gerenciamento Tarefas'
  },
  '自动转码任务': {
    zh: '自动转码任务',
    en: 'Auto Transcode Task',
    ar: 'التلقائي الشفرة المهمة',
    fa: 'وظیفه رمزگذاری خودکار',
    pt: 'Auto Transcode Task'
  },
  '模板管理': {
    zh: '模板管理',
    en: 'Template Management',
    ar: 'إدارة القالب',
    fa: 'مدیریت الگو',
    pt: 'Gerenciamento Modelos'
  },
  '日志管理': {
    zh: '日志管理',
    en: 'Log Management',
    ar: 'إدارة السجل',
    fa: 'مدیریت نتیجه',
    pt: 'Gerenciamento Log'
  },
  'S3存储管理': {
    zh: 'S3存储管理',
    en: 'Storage Management',
    ar: 'إدارة التخزين',
    fa: 'مدیریت ذخیره',
    pt: 'Gestão Armazenamento'
  },
  '媒资管理': {
    zh: '媒资管理',
    en: 'Media Asset',
    ar: 'أصول وسائل الإعلام',
    fa: 'ذخیره رسانه',
    pt: 'Gerenciamento Mídia'
  },
  '转码参数配置': {
    zh: '转码参数配置',
    en: 'Transcoding Parameter',
    ar: 'ترميز الفيديو المعلمات',
    fa: 'ترنسکود پیکربندی',
    pt: 'Transcod Parâmetro'
  },
  '子推荐区域已经存在': {
    zh: '子推荐区域已经存在',
    en: 'The sub recommendation area already exists.',
    ar: 'أوصت المنطقة موجودة بالفعل.',
    fa: 'این منطقه پیشنهاد قبلا وجود دارد',
    pt: 'A área de subrecomendação já existe.'
  },
  '已存在运行中的方案': {
    zh: '已存在运行中的方案',
    en: 'A running scheme already exists.',
    ar: 'مخطط قيد التشغيل موجود بالفعل .',
    fa: 'برنامه‌ی اجرا قبلاً وجود دارد.',
    pt: 'Já existe um esquema em execução.'
  },
  '批量管理': {
    zh: '批量管理',
    en: 'Batch Management',
    ar: 'إدارة متعددة',
    fa: 'مدیریت گروه',
    pt: 'Gestão Lotes'
  },
  '点播批量管理': {
    zh: '点播批量管理',
    en: 'VOD Management',
    ar: 'إدارة الطلب دفعة',
    fa: 'روي مديريت سؤال',
    pt: 'Gerenciamento VOD'
  },
  'CMS数据统计': {
    zh: '数据统计',
    en: 'Statistics',
    ar: 'بيانات إحصائية',
    fa: 'آمار',
    pt: 'Estatísticas'
  },
  '点播节目统计': {
    zh: '点播节目统计',
    en: 'VOD Statistics',
    ar: 'إحصائيات حسب الطلب',
    fa: 'آمار برنامه VOD',
    pt: 'Estatísticas VOD'
  },
  '定制风格': {
    zh: '定制风格',
    en: 'Customized Style',
    ar: 'جعل نمط',
    fa: 'سبک تنظیم',
    pt: 'Estilo Personalizado'
  },
  '存储管理': {
    zh: '存储管理',
    en: 'Storage Management',
    ar: 'إدارة التخزين',
    fa: 'مدیریت ذخیره‌سازی',
    pt: 'Gerenciamento de Armazenamento'
  }
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  // },
  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: '',
  // },

}